import * as React from "react";
import { singleton } from "logic/singleton";
export default singleton(
  "contexts.InputSetupWizardStepsContext",
  () => React.createContext(void 0)
);
